/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, May 2025
 */

/* eslint-disable max-len */
/* flow-disable */

import _ from 'lodash';
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer, DecisionContainer } from '../../containers';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import v from './validators';
import fetch from '../../core/fetch/fetch.server';
import waiting from '../eserviceSummary/waiting-wheel-300x300.gif';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};


class RezerwacjaMiejscaNaCmentarzu extends React.Component {
  state = {
    info: {
      graveyard: null,
      graveType: null,
      cost: 0,
    },
    costDict: {},
    InfoTypeDict: {},
    selectedParcels: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    isMounted: false,
  };

  validators = {
    graveyard: [v.NotSelected],
    graveType: [v.NotSelected],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.fetchGraveYardsInfo());
      });
  }

  fetchGraveYardsInfo  = () => {
    fetch(`${process.env.API_URL}/eservices/${this.props.prefix}/graveyards_info/`)
    .then(r => r.json())
    .then(resp => {
      const graveyards = [];
      const graveTypes = [];
      const costDict = {};
      const InfoTypeDict = {};
      for (const graveyard of resp.graveyards) {
        graveyards.push({
          label: graveyard,
          value: graveyard,
          state: 'graveyard'
        })
      }
      for (const graveType of resp.gravetypes) {
        graveTypes.push({
          label: `${graveType.name} - ${graveType.cost} zł`,
          value: graveType.name,
          state: 'graveType'
        });
        costDict[graveType.name] = graveType.cost;
      }

      InfoTypeDict['graveyard'] = {
        label: 'Cmentarz*',
        editable: true,
        type: 'Select',
        options: graveyards,
      }

      InfoTypeDict['graveType'] = {
        label: 'Rodzaj grobu',
        editable: true,
        type: 'Select',
        options: graveTypes,
      }


      this.setState({
        costDict,
        InfoTypeDict,
        isMounted: true,
      });
    });
  }

  onHide = () => this.setState({ showError: false });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (name == 'graveType' && this.state.costDict) {
      const cost = this.state.costDict[e.value];
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
            cost
          },
        },
        () => this.validate(group, name),
      );
    } else {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
          },
        },
        () => this.validate(group, name),
      );
    }

  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      this.state.isMounted ?
        <div style={{ paddingTop: '20px' }}>
          <h3 style={{ textAlign: 'center' }}>
            {this.props.serviceInfo.eservice.title}
          </h3>
          <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
          <DecisionContainer
            title={'1. Wybór cmentarza i rodzaju grobu'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={this.state.InfoTypeDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          />
          <GrayPanel title="Informacje">
            *Miejsce na cmentarzu zostanie wskazane przez Sołtysa wsi, na której terenie znajduje się cmentarz (po przesłaniu wniosku i dokonaniu opłaty).
          </GrayPanel>
          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />

          {/* BUTTONS */}
          <div className="row mobile-row">
            <div className="col-sm-12">
              <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
              <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
              <button
                type="submit-lg"
                className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={() => this.setState({ progress: 0 }, () => this.startService())}
              >
                Uruchom
              </button>
              <button
                type="submit-lg"
                className="btn btn-default"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={history.goBack}
              >
                Anuluj
              </button>
            </div>
          </div>
        </div>
      :
        <GrayPanel
            title="Trwa ładowanie zawartości..."
            bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}
          >
            <img alt="Loader" src={waiting} />
        </GrayPanel>
    );
  }
}

RezerwacjaMiejscaNaCmentarzu.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(RezerwacjaMiejscaNaCmentarzu),
);



// WEBPACK FOOTER //
// src/routes/eservices/RezerwacjaMiejscaNaCmentarzu.js